import { useEffect, useRef, useState } from 'react';
import 'aframe';

export default function GridTest() {
  const containerRef = useRef<HTMLDivElement>(null);
  const [status, setStatus] = useState('Initializing...');

  useEffect(() => {
    if (!containerRef.current) return;

    setStatus('Creating scene...');

    // Create the scene
    const scene = document.createElement('a-scene');
    scene.setAttribute('embedded', '');
    scene.setAttribute('loading-screen', 'enabled: false');
    scene.setAttribute('vr-mode-ui', 'enabled: false');
    scene.setAttribute('background', 'color: #1a1a2e');
    scene.style.width = '100%';
    scene.style.height = '100%';

    // Create camera
    const camera = document.createElement('a-camera');
    camera.setAttribute('look-controls', 'enabled: true');
    camera.setAttribute('wasd-controls', 'enabled: false');
    camera.setAttribute('fov', '80');
    scene.appendChild(camera);

    // Add scene to container
    containerRef.current.appendChild(scene);
    setStatus('Scene added to DOM...');

    // When scene is loaded, create the grid sphere
    scene.addEventListener('loaded', () => {
      setStatus('Scene loaded event fired!');
      console.log('Scene loaded');

      const THREE = (window as any).THREE;
      const sceneObj = (scene as any).object3D;

      console.log('THREE:', THREE);
      console.log('sceneObj:', sceneObj);

      if (THREE && sceneObj) {
        try {
          // Create wireframe sphere
          const geometry = new THREE.SphereGeometry(100, 32, 16);
          const wireframe = new THREE.WireframeGeometry(geometry);
          const material = new THREE.LineBasicMaterial({ color: 0x00ffff });
          const gridMesh = new THREE.LineSegments(wireframe, material);
          sceneObj.add(gridMesh);

          setStatus('Grid sphere created with THREE.js!');
          console.log('Grid sphere added:', gridMesh);
        } catch (err) {
          setStatus(`Error: ${err}`);
          console.error('Error creating grid:', err);
        }
      } else {
        setStatus(`Missing: THREE=${!!THREE}, sceneObj=${!!sceneObj}`);
      }
    });

    // Also try polling
    let attempts = 0;
    const check = setInterval(() => {
      attempts++;
      const sceneObj = (scene as any).object3D;
      if (sceneObj && !(window as any).__gridTestCreated) {
        console.log(`Poll attempt ${attempts}: scene ready`);
        const THREE = (window as any).THREE;
        if (THREE) {
          (window as any).__gridTestCreated = true;
          clearInterval(check);

          const geometry = new THREE.SphereGeometry(100, 32, 16);
          const wireframe = new THREE.WireframeGeometry(geometry);
          const material = new THREE.LineBasicMaterial({ color: 0x00ffff });
          const gridMesh = new THREE.LineSegments(wireframe, material);
          sceneObj.add(gridMesh);
          setStatus(`Grid created via polling (attempt ${attempts})`);
        }
      }
      if (attempts > 100) {
        clearInterval(check);
        setStatus('Polling timed out');
      }
    }, 50);

    return () => {
      clearInterval(check);
      if (containerRef.current?.contains(scene)) {
        containerRef.current.removeChild(scene);
      }
    };
  }, []);

  return (
    <div className="fixed inset-0 bg-black">
      <div ref={containerRef} className="w-full h-full" />
      <div className="absolute top-4 left-4 text-white bg-black/50 p-4 rounded z-50">
        <h2 className="text-lg font-bold mb-2">Grid Test</h2>
        <p>Status: {status}</p>
        <p className="text-sm text-white/60 mt-2">Drag to look around</p>
      </div>
    </div>
  );
}
